module.exports = __webpack_public_path__ + "static/img/11_4Archive_5g_Kaprow_Soap_cancellation.6b757fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/11_4Archive_5g_Kaprow_Soap_cancellation.jpg
// module id = m/QE
// module chunks = 0